(function () {
  const scienceData = {
    energie: {
      title: "Énergie et performance",
      text: "Plusieurs recherches explorent le rôle potentiel du Shilajit dans l’énergie cellulaire, l’endurance physique et certains mécanismes liés à la récupération musculaire.",
      points: [
        "production énergétique cellulaire",
        "fatigue physique",
        "récupération musculaire",
        "adaptation à l’effort",
        "altitude et oxygénation"
      ],
      articles: [
        { label: "Fatigue et endurance", url: "https://pureshilajithimalaya.fr/blogs/resume-d-etudes-scientifiques-du-shilajit/impact-du-shilajit-sur-la-fatigue-musculaire" },
        { label: "Adaptation musculaire", url: "https://pureshilajithimalaya.fr/blogs/resume-d-etudes-scientifiques-du-shilajit/effets-du-shilajit-sur-le-transcriptome-musculaire-humain" },
        { label: "Problèmes d’altitude", url: "https://pureshilajithimalaya.fr/blogs/resume-d-etudes-scientifiques-du-shilajit/le-shilajit-comme-solution-aux-problemes-daltitude" },
        { label: "Consolidation osseuse", url: "https://pureshilajithimalaya.fr/blogs/resume-d-etudes-scientifiques-du-shilajit/efficacite-du-momiai-dans-la-reparation-des-fractures-du-tibia" },
        { label: "Santé osseuse", url: "https://pureshilajithimalaya.fr/blogs/resume-d-etudes-scientifiques-du-shilajit/effets-du-shilajit-sur-la-proliferation-cellulaire" },
        { label: "Prévention et soutien cardiaque", url: "https://pureshilajithimalaya.fr/blogs/resume-d-etudes-scientifiques-du-shilajit/effet-cardioprotecteur-du-shilajit-sur-les-lesions-myocardiques" }
      ]
    },

    cerveau: {
      title: "Cerveau et cognition",
      text: "Certaines études s’intéressent au rôle potentiel du Shilajit sur les fonctions cognitives, la mémoire, le stress oxydatif cérébral et certains mécanismes neuroprotecteurs.",
      points: [
        "mémoire et fonctions cognitives",
        "neuroprotection",
        "stress oxydatif cérébral",
        "douleur nerveuse",
        "système nerveux"
      ],
      articles: [
        { label: "Potentiel neuroprotecteur", url: "https://pureshilajithimalaya.fr/blogs/resume-d-etudes-scientifiques-du-shilajit/shilajit-et-son-potentiel-neuroprotecteur" },
        { label: "Épilepsie et troubles psychotiques", url: "https://pureshilajithimalaya.fr/blogs/resume-d-etudes-scientifiques-du-shilajit/activites-antipsychotiques-et-antiepileptiques-du-shilajit-standardise" },
        { label: "Alzheimer et vitamines B", url: "https://pureshilajithimalaya.fr/blogs/resume-d-etudes-scientifiques-du-shilajit/les-nutraceutiques-peuvent-ils-prevenir-la-maladie-dalzheimer-role-potentiel-du-shilajit-et-des-vitamines-b" },
        { label: "Douleur nerveuse", url: "https://pureshilajithimalaya.fr/blogs/resume-d-etudes-scientifiques-du-shilajit/actions-du-shilajit-sur-les-neurones-de-la-substantia-gelatinosa" },
        { label: "Pression intracrânienne", url: "https://pureshilajithimalaya.fr/blogs/resume-d-etudes-scientifiques-du-shilajit/effets-du-shilajit-sur-loedeme-cerebral-la-pression-intracranienne-et-les-resultats-neurologiques-apres-un-traumatisme-cerebral" },
        { label: "Chimie du sang", url: "https://pureshilajithimalaya.fr/blogs/resume-d-etudes-scientifiques-du-shilajit/effets-du-shilajit-sur-la-chimie-sanguine-chez-les-humains" }
      ]
    },

    hormones: {
      title: "Hormones et fertilité",
      text: "Les recherches autour du Shilajit explorent aussi certains marqueurs hormonaux, la fertilité masculine et différents mécanismes liés à la vitalité reproductive.",
      points: [
        "testostérone",
        "qualité spermatique",
        "fertilité masculine",
        "équilibre hormonal",
        "santé reproductive"
      ],
      articles: [
        { label: "Shilajit et testostérone", url: "https://pureshilajithimalaya.fr/blogs/resume-d-etudes-scientifiques-du-shilajit/evaluation-clinique-de-leffet-du-shilajit-sur-les-niveaux-de-testosterone" },
        { label: "Équilibre hormonal", url: "https://pureshilajithimalaya.fr/blogs/resume-d-etudes-scientifiques-du-shilajit/le-role-du-shilajit-dans-l-equilibre-hormonal" },
        { label: "Fertilité masculine", url: "https://pureshilajithimalaya.fr/blogs/resume-d-etudes-scientifiques-du-shilajit/effets-profertiles-du-shilajit-sur-linfertilite-induite-par-le-cadmium" },
        { label: "Santé reproductive", url: "https://pureshilajithimalaya.fr/blogs/resume-d-etudes-scientifiques-du-shilajit/effets-spermatogeniques-et-ovogeniques-du-shilajit-chez-les-rats" },
        { label: "Shilajit et femmes", url: "https://pureshilajithimalaya.fr/blogs/resume-d-etudes-scientifiques-du-shilajit/le-shilajit-est-il-adapte-aux-femmes-analyse-scientifique" },
        { label: "Études sur les ovaires", url: "https://pureshilajithimalaya.fr/blogs/resume-d-etudes-scientifiques-du-shilajit/le-shilajit-sur-lapoptose-induite-par-les-radiations-dans-les-ovaires" }
      ]
    },

    immunite: {
      title: "Inflammation et immunité",
      text: "Plusieurs travaux abordent le Shilajit sous l’angle de l’inflammation, du stress oxydatif, des défenses naturelles et de certaines formes de douleur chronique.",
      points: [
        "inflammation",
        "douleur chronique",
        "stress oxydatif",
        "défenses naturelles",
        "activité antivirale"
      ],
      articles: [
        { label: "Douleur inflammatoire", url: "https://pureshilajithimalaya.fr/blogs/resume-d-etudes-scientifiques-du-shilajit/shilajit-et-douleur-inflammatoire" },
        { label: "Effets anti-ulcéreux", url: "https://pureshilajithimalaya.fr/blogs/resume-d-etudes-scientifiques-du-shilajit/etudes-anti-ulcereuses-et-anti-inflammatoires-du-shilajit" },
        { label: "Activité antivirale", url: "https://pureshilajithimalaya.fr/blogs/resume-d-etudes-scientifiques-du-shilajit/activite-antivirale-des-substances-humiques-naturelles-et-du-shilajit-contre-le-vih-1" },
        { label: "Étude clinique VIH", url: "https://pureshilajithimalaya.fr/blogs/resume-d-etudes-scientifiques-du-shilajit/evaluation-clinique-du-shilajit-chez-les-patients-atteints-par-le-vih" },
        { label: "Propriétés antivirales in vitro", url: "https://pureshilajithimalaya.fr/blogs/resume-d-etudes-scientifiques-du-shilajit/proprietes-antivirales-du-shilajit" },
        { label: "Tolérance à la morphine", url: "https://pureshilajithimalaya.fr/blogs/resume-d-etudes-scientifiques-du-shilajit/effets-du-shilajit-sur-la-tolerance-a-la-morphine" }
      ]
    },

    metabolisme: {
      title: "Métabolisme et vieillissement",
      text: "Le Shilajit est également étudié pour ses liens potentiels avec le métabolisme énergétique, le vieillissement cellulaire, les antioxydants et certains mécanismes tissulaires.",
      points: [
        "métabolisme énergétique",
        "vieillissement cellulaire",
        "stress oxydatif",
        "santé de la peau",
        "assimilation des nutriments"
      ],
      articles: [
        { label: "Troubles métaboliques", url: "https://pureshilajithimalaya.fr/blogs/resume-d-etudes-scientifiques-du-shilajit/effets-du-shilajit-sur-les-troubles-metaboliques" },
        { label: "8 bienfaits étudiés", url: "https://pureshilajithimalaya.fr/blogs/resume-d-etudes-scientifiques-du-shilajit/8-bienfaits-du-shilajit" },
        { label: "Santé de la peau", url: "https://pureshilajithimalaya.fr/blogs/resume-d-etudes-scientifiques-du-shilajit/shilajit-et-sante-de-la-peau-analyse-scientifique-chez-la-femme" },
        { label: "Effets anticancéreux étudiés", url: "https://pureshilajithimalaya.fr/blogs/resume-d-etudes-scientifiques-du-shilajit/le-shilajit-et-ses-effets-anticancereux" },
        { label: "Hyperplasie de la prostate", url: "https://pureshilajithimalaya.fr/blogs/resume-d-etudes-scientifiques-du-shilajit/hyperplasie-benigne-de-la-prostate-et-le-shilajit" },
        { label: "Propriétés thérapeutiques du Tasmayi", url: "https://pureshilajithimalaya.fr/blogs/resume-d-etudes-scientifiques-du-shilajit/avancees-dans-la-recherche-sur-le-tasmayi" }
      ]
    }
  };

  function initScienceExplorer() {
    const explorers = document.querySelectorAll(".psh-science-explorer");

    explorers.forEach(function (explorer) {
      if (explorer.dataset.initialized === "true") return;
      explorer.dataset.initialized = "true";

      const buttons = explorer.querySelectorAll("[data-science]");
      const result = explorer.querySelector(".psh-science-result");

      if (!buttons.length || !result) return;

      buttons.forEach(function (button) {
        button.addEventListener("click", function () {
          const key = button.getAttribute("data-science");
          const item = scienceData[key];

          if (!item) return;

          const pointsHtml = item.points.map(function (point) {
            return `<li>✓ ${point}</li>`;
          }).join("");

          const articlesHtml = item.articles.map(function (article) {
            return `<a href="${article.url}" class="psh-science-link">${article.label}</a>`;
          }).join("");

          result.innerHTML = `
            <div class="psh-science-card psh-compare-result">
              <h3>${item.title}</h3>
              <p>${item.text}</p>

              <div class="psh-science-points">
                <strong>Ce que les études analysent :</strong>
                <ul>
                  ${pointsHtml}
                </ul>
              </div>

              <div class="psh-science-links">
                <strong>Recherches scientifiques associées :</strong>
                ${articlesHtml}
              </div>
            </div>
          `;

          const yOffset = -120;
          const y = result.getBoundingClientRect().top + window.pageYOffset + yOffset;

          window.scrollTo({
            top: y,
            behavior: "smooth"
          });
        });
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initScienceExplorer);
  } else {
    initScienceExplorer();
  }
})();